import React from 'react'
import { TopHeader } from './TopHeader/TopHeader'
import { BottomHeader } from './BottomHeader/BottomHeader'
import { VirusBanner } from './VirusBanner/VirusBanner'
import './MainSectionHeader2.scoped.sass'

export function MainSectionHeader2 (props) {
  const {
    message,
    thread,
    viewType,
    colorData,
    darkenHeaderIfDense,
    toggleMessageOnClick,
    hideMessageBody
  } = props
  return <header>
    <TopHeader
      toggleMessageOnClick={toggleMessageOnClick}
      darkenHeaderIfDense={darkenHeaderIfDense}
      colorData={colorData}
      viewType={viewType}
      thread={thread}
      message={message}
      hideMessageBody={hideMessageBody}
      />
    {viewType === 'normal' && <BottomHeader message={message} thread={thread} />}
    {viewType === 'normal' && (message && !message.isvirusfree) && <VirusBanner />}
  </header>
}
